import React from 'react';
import {Input} from "../input";
import {CheckoutAgreement} from "../checkout-agreement/checkout-agreement";

class CreateAccount extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            accountAgreement,
            accountPrivacyAgreement,
            changeAccountAgreement,
            changeAccountPrivacyAgreement,
            textsMapping,
            isLoggedIn,
            trimInput
        } = this.props;

        return (
            <section className="checkout-section create-account">
                <h3 className="checkout-section__title">{textsMapping.createAccountTitle}</h3>
                <p dangerouslySetInnerHTML={{__html: textsMapping.createAccountText}}/>

                <Input
                    resourcedTexts={textsMapping}
                    inputType="email"
                    inputLabel={textsMapping.createAccountEmailLabel}
                    placeHolder={textsMapping.createAccountEmailPlaceholder}
                    autoComplete={"username"}
                    path='customerData.accountDetails.email'
                    errorMessage={textsMapping.inputErrorMessageEmail}
                    required={!isLoggedIn}
                    onBlurFunction={trimInput}
                />

                <Input
                    resourcedTexts={textsMapping}
                    inputType="password"
                    inputLabel={textsMapping.createAccountPasswordLabel}
                    placeHolder={textsMapping.createAccountPasswordPlaceholder}
                    autoComplete={"new-password"}
                    path='customerData.accountDetails.password'
                    errorMessage={textsMapping.inputErrorMessagePassword}
                    required={!isLoggedIn}
                />

                <Input
                    resourcedTexts={textsMapping}
                    inputType="password"
                    inputLabel={textsMapping.createAccountPasswordRepeatLabel}
                    placeHolder={textsMapping.createAccountPasswordRepeatPlaceholder}
                    autoComplete={"new-password"}
                    path='customerData.accountDetails.passwordRepeat'
                    errorMessage={textsMapping.inputErrorMessagePasswordMatch}
                    required={!isLoggedIn}
                />

                <CheckoutAgreement
                    id='account-agreement'
                    resourcedTexts={textsMapping}
                    accountAgreement={accountAgreement}
                    accountAgreementText={textsMapping.createAccountAgreementText}
                    changeAccountAgreement={changeAccountAgreement}
                />

                <CheckoutAgreement
                    id='account-privacy-agreement'
                    resourcedTexts={textsMapping}
                    accountAgreement={accountPrivacyAgreement}
                    accountAgreementText={textsMapping.createAccountPrivacyStatementText}
                    changeAccountAgreement={changeAccountPrivacyAgreement}
                />

                <div className="create-account__usp-list"
                     dangerouslySetInnerHTML={{__html: textsMapping.createAccountUspList}}
                />
            </section>
        )
    };

};

export {CreateAccount};